module.exports = __webpack_public_path__ + "static/img/image-1.3a490adc.png";